<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="w-20 h-20 mx-auto text-gray-400 animate-zoom-rotate"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
      d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z" />
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 17
    },
    height: {
      type: [Number, String],
      default: 21
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>

<style>
@keyframes zoomRotate {
  0% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.2) rotate(180deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
  }
}

.animate-zoom-rotate {
  animation: zoomRotate 2s infinite ease-in-out;
}
</style>
